export const ANIMATION_CONFIG = {
    CHIPS: {
        X: {
            stiffness: 200,
            damping: 45,
            mass: 0.25,
            restDelta: 0.001,
            restSpeed: 0.001,
        },
        SCALE: {
            stiffness: 180,
            damping: 30,
        },
    },
    AVATARS: {
        X: {
            stiffness: 100,
            damping: 30,
            mass: 0.8,
        },
        SCALE: {
            stiffness: 200,
            damping: 40,
        },
    },
    SCROLL: {
        spring: {
            stiffness: 120,
            damping: 35,
            mass: 0.7,
            restDelta: 0.01,
            restSpeed: 0.01,
        },
        offset: ['start start', 'end end'] as const,
        pin: {
            duration: 1.39,
            startOffset: 0,
        },
    },
} as const;
